import React, { useCallback } from 'react';

import RadioButton from './RadioButton';
import './RadioGroup.scss';

const RadioGroup = ({ options, value: valueProps, onChange, name, emptyValue = '', isEmpty = false }) => {
  const handleSelect = useCallback(
    (e) => {
      const { value } = e.currentTarget;

      if (isEmpty && value === valueProps) {
        onChange(emptyValue);
        return;
      }

      onChange(value);
    },
    [onChange, isEmpty, emptyValue, valueProps],
  );

  return (
    <div className='radio-group_wrapper'>
      {options.map(({ label, value, disabled }) => (
        <RadioButton
          value={value}
          label={label}
          key={value}
          id={`radio-option-${name}-${value}`}
          name={name}
          disabled={disabled}
          onClick={handleSelect}
          checked={value === valueProps}
        />
      ))}
    </div>
  );
};

export default RadioGroup;
